const places = [{
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/9",
	"name": "Museu da Amazônia - MUSA",
	"small_name": "Museu da Amazônia",
	"id": "9",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Av Margarita, s/n - Cidade de Deus",
	"phone_number": "(92) 3582-3188",
	"opening_hours": "Quinta a terça - 8h30 às 17h (o portão de entrada fecha às 16h)\r\nQuarta é o único dia da semana em que o Musa está fechado para manutenção",
	"desc": "Localizado na Reserva Florestal Adolpho Ducke, com mais de 100Km², o Museu da Amazônia é um museu vivo em um dos maiores Jardins Botânicos do Brasil, com cerca de 3 km de acesso a diferentes ecossistemas da região.\r\nPossui centro administrativo, biblioteca, lanchonete, estacionamento e trilhas ecológicas que permitem aos visitantes conhecer diferentes ecossistemas da região como, por exemplo, a floresta de baixo. Ao longo das trilhas existem diversas árvores identificadas e pode-se encontrar o angelim-pedra, castanha-de-macaco, acariquara, breu, tachi, entre outras espécies da região. Outro passeio imperdível é a subida na torre de observação, feita de aço e com 42 metros de altura. ",
	"map_description": "O Museu da Amazônia, localizado na Reserva Florestal Adolpho Ducke, é um museu vivo dentro da área remanescente da floresta primária de Manaus.",
	"social_description": "",
	"location": {
		"lat": "-3.00701091599996",
		"lng": "-59.939731266",
		"timeout": "30",
		"radius": "75",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Musa/Musa-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Musa/Musa-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Musa/Musa-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Musa/Musa-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Musa/Musa-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "A floresta sob um novo olhar",
		"description": "Que segredos escondem as águas do rio Negro? Que constelações as diversas etnias indígenas amazônicas identificam no céu? Como um mosquito vê a floresta ao seu redor? Seria possível \"enxergar\" o ar que se move entre a copa das árvores?\r\nA complexidade e a rica diversidade social e biológica da Amazônia suscitam perguntas. Para algumas, as respostas já existem. Para outras, as descobriremos. Imaginar perguntas e buscar respostas é o que propõe o Museu da Amazônia, ou Musa.\r\nPara cumprir esse objetivo, é preciso ir ao encontro da natureza. Os sentidos, como o tato e a visão, não são os únicos aliados na jornada - microscópios, lupas e micro câmeras podem colaborar. Muitas vezes, é preciso sair da posição de observador, ser pássaro ou formiga, para entender como um pássaro vê ou o modo como uma formiga percebe o mundo. Como? É o que queremos saber.\r\nEste é o convite que o Musa faz a seus visitantes: ver a floresta com um novo olhar. Pensá-la como a pensam os que nela vivem, com suas culturas e modos de sobrevivência e reprodução.",
		"filename": "09-01-musa-pt.mp3",
		"author": "Ennio Candotti",
		"author_job": "Diretor do Museu"
	}, {
		"title": "O que você encontrará lá",
		"description": "Criado em janeiro de 2009, o Musa ocupa 100 hectares da Reserva Florestal Adolpho Ducke, do Instituto Nacional de Pesquisas da Amazônia - INPA, em Manaus. Uma reserva de floresta primária, que se estende por 100 km2 na periferia de Manaus.\r\nNo Musa encontramos exposições, viveiro de orquídeas e bromélias, lago, aquários e laboratórios experimentais de serpentes, de insetos e de borboletas.\r\nTrilhas na floresta proporcionam ao visitante passeios agradáveis e descobertas surpreendentes. No Musa são desenvolvidas pesquisas em divulgação e popularização da ciência e da educação científica e cultural.",
		"filename": "09-02-musa-pt.mp3",
		"author": "Ennio Candotti",
		"author_job": "Diretor do Museu"
	}, {
		"title": "A torre de observação",
		"description": "Um dos principais atrativos do Musa é a torre de observação, com 42 metros de altura, desde onde se pode admirar uma magnífica vista do dossel das árvores da floresta.\r\nNo lusco-fusco da manhã, por volta das seis horas, pode-se observar as copas das árvores brotando da neblina, despertando da noite. Os pássaros acordam, e com eles os passarinheiros (bird watchers), que para ouvir o canto ou clicar uma ave sobem a torre com seus binóculos e suas poderosas teleobjetivas.\r\nAos poucos a névoa se esvai, os verdes dominam. O sol, discreto no horizonte, observa e ilumina. Pode-se admirar a vegetação, flores e folhas que, silenciosas, refletem luzes e sombras. Centenas de tons de verde vibrantes e diferentes. Contagiantes.\r\nA torre convida também à observação do pôr do sol, de 17h30 às 18h30, conforme a época do ano. Ou ainda, é céu noturno que convida, e a torre tem sido utilizada por astrônomos amadores.\r\nCasa de cultura e ciência, de convivência e celebração da diversidade do ser no mundo. Este é o Musa!",
		"filename": "09-03-musa-pt.mp3",
		"author": "Ennio Candotti",
		"author_job": "Diretor do Museu"
	}],
	"more_places": [17, 16, 5, 18, 7]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/8",
	"name": "Encontro das Águas",
	"small_name": "Encontro das Águas",
	"id": "8",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Careiro da Várzea",
	"phone_number": "(92) 3215-3473",
	"opening_hours": "Consulte uma agência de viagens para fazer o passeio",
	"desc": "O Encontro das Águas é um fenômeno que acontece na confluência entre o rio Negro, de água preta, e o rio Solimões, de água barrenta, onde as águas dos dois rios correm lado a lado sem se misturar por uma extensão de mais de 6 km.  \r\n\r\nEsse fenômeno acontece em decorrência da diferença entre a temperatura e densidade das águas e, ainda, à velocidade de suas correntezas: o Rio Negro corre cerca de 2 km/h a uma temperatura de 28°C, enquanto que o Rio Solimões corre de 4 a 6 km/h a uma temperatura de 22°C. \r\n\r\nO Encontro das Águas, tombado pelo Instituto do Patrimônio Histórico e Artístico Nacional (IPHAN), é uma das maiores referências de patrimônio imaterial de Manaus e um dos mais belos pontos turísticos da capital amazonense que pode ser contemplado em passeios de barcos e hidroaviões. ",
	"map_description": "O Encontro das Águas é um fenômeno que acontece na confluência entre o rio Negro, de água preta, e o rio Solimões, de água barrenta, onde as águas dos dois rios correm lado a lado sem se misturar. ",
	"social_description": "",
	"location": {
		"lat": "-3.13494615299993",
		"lng": "-59.901618465",
		"timeout": "30",
		"radius": "1500",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Encontro-das-aguas/EncontroAguas-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Encontro-das-aguas/EncontroAguas-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Encontro-das-aguas/EncontroAguas-03-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Encontro das Águas",
		"description": "O Rio Negro e o Solimões\r\nganham dimensões do mar\r\nao se encontrar em Manaus\r\nnum abraço espetacular\r\ncom suas águas diferentes\r\nbordejam desde as nascentes\r\npara este solo beijar.\r\n\r\nCaminham longas distâncias\r\ncada qual com sua cor\r\nsugerindo aos navegantes\r\num cenário encantador\r\nembalado pela aragem\r\nque na dança das ramagens\r\nrefletem paz e esplendor.\r\n\r\nGuardam saudosas memórias\r\ndos vários grupos tribais\r\nno regime das enchentes\r\ntornam-se cartões postais\r\nexpressão de Deus que canta\r\nonde tudo se agiganta\r\nna orquestra dos matagais.\r\n\r\nO Negro, calmo e profundo\r\nespelha a imagem encantada\r\ndos ritos e das histórias\r\nque um dia foram contadas\r\nde tanta gente aguerrida\r\ne das milhares de vidas\r\nque aqui foram tombadas.\r\n\r\nO Solimões de águas turvas\r\nesbanja vida abundante\r\nvai derrubando os barrancos\r\ncom seu ímpeto constante\r\nperde seu nome no abraço\r\npara seguir no compasso\r\ndo colosso itinerante.\r\n\r\nOnde as águas se separam\r\npra manifestar trindade\r\nSolimões , Negro, Amazonas\r\nganham o dom da unidade\r\nnessa graça recebida\r\ntornam-se exemplo de vida\r\npara toda humanidade. \r\n \r\nManaus cabocla risonha\r\nna amplidão do doce olhar\r\nvê no encontro das águas\r\num portal para sonhar\r\ne o reparte com alegria\r\ndenso de amor e magia\r\npara quem vem nos visitar.",
		"filename": "08-01-aguas-pt.mp3",
		"author": "Celdo Braga",
		"author_job": "Músico e pesquisador"
	}],
	"more_places": [41, 31, 5, 18, 23]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/1",
	"name": "Complexo Turístico da Ponta Negra",
	"small_name": "Ponta Negra",
	"id": "1",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Av. Coronel Teixeira - Ponta Negra",
	"phone_number": "(92) 3215-3473",
	"opening_hours": "O passeio público e a praia são abertos a população 24h; os horários dos quiosques variam de acordo com cada empreendimento.",
	"desc": "Localizado à margem esquerda do Rio Negro, a aproximadamente 13 km do centro de Manaus, o Complexo Turístico da Ponta Negra é um dos principais cartões postais da cidade e também é um dos espaços urbanos mais democráticos, sendo amplamente frequentado pelos moradores de todas as idades e de todas as zonas da cidade, que vão em busca de lazer, esporte, contato com a natureza e diversão. \r\n\r\nO Complexo possui orla urbanizada, calçadas com pedras portuguesas, quadras para prática de esportes, jardins, mirantes, ciclovia, praça com chafariz, quiosques de comidas e bebidas e um anfiteatro onde são realizadas apresentações musicais, espetáculos teatrais e outras atividades culturais.  \r\n\r\nÀs quartas-feiras e aos domingos as vias são interditadas para o fluxo automotivo, permitindo assim a prática de atividades esportivas na \"faixa liberada\". Para os ciclistas, o local oferece uma Estação de Reparos Rápidos de Bicicletas, equipada com um conjunto de ferramentas básicas para reparos nas bikes, como chaves e bomba de ar. \r\n\r\nVale ressaltar que do Complexo Turístico da Ponta Negra é possível ter uma vista privilegiada da ponte sobre o Rio Negro, Ponte Pelippe Daou e, a partir das 17h, presenciar o pôr-do-sol mais bonito da cidade. \r\n",
	"map_description": "O Complexo Turístico da Ponta Negra é um dos principais cartões postais da cidade e também um dos melhores locais para ver o pôr do sol sobre o Rio Negro. ",
	"social_description": "",
	"location": {
		"lat": "-3.06491935099996",
		"lng": "-60.103529309",
		"timeout": "30",
		"radius": "300",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-05-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponta-Negra/PontaNegra-06-1242X1200.jpg"],
	"audio_guide": [{
		"title": "História da Ponta Negra",
		"description": "O complexo Turístico Ponta Negra é hoje um dos principais cartões postais da cidade de Manaus, com diversas opções de atividades esportivas e de lazer para toda a família. \r\nAntigamente, aquela região foi residência de uma grande concentração de índios da tribo Manáos, que deram origem ao nome da cidade de Manaus.\r\nO acesso à praia da Ponta Negra, por muito tempo, ocorria somente através de barcos, dado seu isolamento em relação aos demais bairros de Manaus. Somente nos anos 1960 foi aberta uma via de acesso ao local, e mesmo assim, chegar até a praia poderia ser uma aventura, pois a estrada era de barro e não oferecia segurança aos transeuntes ou aos condutores.\r\nNos anos 1990, a Ponta Negra foi modernizada e cerca de 2 km de orla foram dotados de uma diversa infraestrutura, contendo calçadão, quadras de esportes, bares, banheiros públicos, entre outros serviços. \r\nEntre os anos de 2011 e 2013, a região passou por um novo processo de reurbanização e a praia recebeu cerca de um milhão de metros cúbicos de areia, se tornando uma praia perene, gratuita e aberta 24 horas para turistas e moradores da cidade. Com isso, a praia, antes restrita ao período de seca do Rio Negro, passou a ser frequentada o ano todo.",
		"filename": "01-01-ponta-negra-pt.mp3",
		"author": "Marcus Pessoa",
		"author_job": "Jornalista, idealizador do portal de noticias No Amazonas É Assim"
	}, {
		"title": "Opções de lazer para todos",
		"description": "Visitar o Complexo Turístico da Ponta Negra é indispensável para quem deseja conhecer as belezas da capital amazonense. No local, é possível encontrar lanchonetes, bares, sorveteria, e o visitante pode experimentar um delicioso tacacá ou tomar um açaí geladinho apreciando as águas escuras do Rio Negro. \r\nOutro destaque é o projeto Faixa Liberada, que consiste na interdição das ruas para o trânsito de veículos, permitindo que as mesmas fiquem livres para a circulação dos pedestres e à prática de diversos esportes, como o ciclismo, caminhada, corrida, patinação, aulas de dança, funcional, entre muitos outros.\r\nCom o tempo e de forma natural, a região tornou-se um ponto de encontro onde os manauaras vão para passear com a família, namorar, se divertir e comemorar diferentes eventos e conquistas da cidade. Durante a Copa do Mundo FIFA de 2014, a Ponta Negra foi o local escolhido pra sediar o \"Fifa Fan Fest\", um evento de exibição pública dos jogos com ampla programação cultural, no qual milhares de pessoas lotaram o anfiteatro da Ponta Negra para acompanhar as partidas e fazer amizades. \r\nNa Ponta Negra também são realizados eventos turísticos e culturais de grande importância para a cidade, como o Festival Folclórico do Amazonas, o Boi Manaus e o Réveillon da Cidade. \r\nSe você busca um dos melhores pôr do sol de sua vida, irá amar ver o sol beijar o doce rio. Aliás, muitos dos visitantes que chegam à Manaus se surpreendem com o tamanho do leito do Rio Negro, muito maior que os encontrados em outros lugares do mundo. Não por acaso, o escritor amazonense Milton Hatoum definiu o Rio Negro como um \"rio fabuloso, de águas pretas, com dez quilômetros de largura, um rio que é um mar\".",
		"filename": "01-02-ponta-negra-pt.mp3",
		"author": "Marcus Pessoa",
		"author_job": "Jornalista, idealizador do portal de noticias No Amazonas É Assim"
	}],
	"more_places": [15, 13, 14, 42, 6]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/2",
	"name": "Reserva do Tupé",
	"small_name": "RDS Tupé",
	"id": "2",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "O acesso é feito exclusivamente por via fluvial pela Marina do Davi ou pelo Porto da Manaus Moderna.",
	"phone_number": "(92) 3236-7060",
	"opening_hours": "Consulte uma agência de viagens para fazer o passeio.",
	"desc": "A Reserva de Desenvolvimento Sustentável (RDS) do Tupé é uma área de 11.973 hectares, localizada a 34 km de Manaus, às margens do rio Negro, formada por seis comunidades: Livramento, Julião, Colônia Central, Tatu, São João do Lago do Tupé e Agrovila. O acesso é feito exclusivamente por via fluvial pela Marina do Davi, zona Centro-Oeste, ou pelo Porto da Manaus Moderna.   \r\n\r\nUma das principais praias fluviais do rio Negro, a praia do Tupé, é um dos seus principais atrativos turísticos, assim como trilhas pela densa mata e a visitação à tribos indígenas. \r\n\r\nApenas operadoras de turismo com cadastro de prestadores de serviços turísticos (Cadastur) do Ministério do Turismo e autorização da Secretaria Municipal de Meio Ambiente e Sustentabilidade (Semmas) podem realizar a visitação turística nos núcleos indígenas localizados no território do Tupé.  \r\n\r\nDatas, horários e valores das apresentações são combinados entre as operadoras e os núcleos indígenas. O acesso às praias é gratuito e aberto à população em geral. ",
	"map_description": "A RDS do Tupé abriga em seu interior uma diversidade biológica riquíssima e o desafio de conciliar estes recursos com as populações tradicionais residentes. ",
	"social_description": "",
	"location": {
		"lat": "-3.04402379299995",
		"lng": "-60.257136891",
		"timeout": "30",
		"radius": "1000",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/RDS-Tupe/Tupe-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/RDS-Tupe/Tupe-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/RDS-Tupe/Tupe-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/RDS-Tupe/Tupe-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/RDS-Tupe/Tupe-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Composição da Reserva",
		"description": "A Reserva de Desenvolvimento Sustentável do Tupé, ou RDS do Tupé, está localizada à margem esquerda do rio Negro e à margem direita do rio Tarumã-mirim. Ela abriga hoje seis comunidades denominadas Agrovila, Julião, Livramento, Colônia Central, São João do Tupé e Tatu.\r\n A Reserva faz limite ao norte com a RDS - Puranga Conquista e com a Área de Proteção Ambiental da Margem Esquerda do Rio Negro - Setor Tarumã Açu/Tarumã Mirim. E, ao sul, com a Área de Proteção Ambiental da Margem Direita do Rio Negro - Setor Paduari/Solimões.",
		"filename": "02-01-tupe-pt.mp3",
		"author": "Marco Antonio Vaz de Lima",
		"author_job": "Chefe da RDS do Tupé, SEMMAS"
	}, {
		"title": "Um mosaico de diversidades",
		"description": "A Reserva do Tupé é um importante marco da administração pública municipal de Manaus junto ao Mosaico do Baixo Rio Negro, e é uma das áreas protegidas do Corredor Central da Amazônia. Possui importância estratégica dentro deste mosaico, seja por sua localização privilegiada, próximo ao chamado Estreito do Rio Negro, área importante para controle da região, através da proteção e fiscalização efetiva da navegação do Rio Negro; seja por abrigar em seu interior uma diversidade biológica riquíssima e o desafio de conciliar estes recursos com as populações tradicionais residentes. \r\nA Reserva do Tupé é uma área com um forte potencial turístico. O ponto de maior concentração de visitantes é a praia do Tupé, além de outras praias populares como Escondidinho, Amor, Luciano e Arrombado. Há, também, um grande movimento de turistas estrangeiros nas ocas indígenas da comunidade São João do Tupé. Outras áreas de recreação são as trilhas, praias, cachoeiras, pousadas e hotéis.\r\nAs opções de lazer que podem ser encontradas são: visita às praias, almoço nas barracas de restaurantes, acampamento, participar de rituais indígenas na Comunidade São João do Tupé, e trilhas, como a do Sauim de coleira, que vai da comunidade do Julião, passa pela comunidade Colônia Central, chegando até a comunidade São João do Tupé. Parte desses atrativos fazem parte do roteiro Tucorin - Turismo Comunitário no Rio Negro.",
		"filename": "02-02-tupe-pt.mp3",
		"author": "Marco Antonio Vaz de Lima",
		"author_job": "Chefe da RDS do Tupé, SEMMAS"
	}, {
		"title": "Um pouco da história",
		"description": "O termo Tupé que dá nome à Unidade de Conservação, é de origem indígena, que significa na linguagem Tupi entrançado, tecidos trançados com talas da planta arumã, usado para fabricar objetos de arte, tapetes, esteiras, toldos de barcos, dentre outras utilidades. \r\nA região do Baixo Rio Negro, no momento da chegada dos colonizadores, era habitada principalmente pelos povos indígenas das tribos Tarumã, Manáos e Baré. Em decorrência dos empreendimentos mercantis e religiosos, guerras e epidemias instaladas após a chegada dos colonizadores europeus, estes indígenas passaram por processos históricos de transformação cultural e perda populacional, chegando até a extinção absoluta de alguns deles. \r\nA região que compreende a RDS do Tupé foi habitada por índios da tribo Baré, conforme os achados de fragmentos de peças de sítios arqueológicos, como cacos de louças feitas de barro e outros objetos de uso doméstico, que eram fabricados por esses moradores. \r\nCom a chegada dos colonizadores, os índios foram abandonando suas terras e a Reserva do Tupé foi tornando-se desabitada. Os Baré localizam-se atualmente no Baixo Rio Negro, enquanto os Manáos e Tarumã foram praticamente extintos. ",
		"filename": "02-03-tupe-pt.mp3",
		"author": "Marco Antonio Vaz de Lima",
		"author_job": "Chefe da RDS do Tupé, SEMMAS"
	}, {
		"title": "As comunidades e os seus moradores",
		"description": "Fundada em 5 de agosto de 1973 por um grupo de trabalhadores ligados ao Sindicato dos Trabalhadores Rurais, a comunidade Nossa Senhora do Livramento foi a primeira a ser criada na região da Reserva do Tupé. Na comunidade Agrovila, existe um museu que guarda achados arqueológicos dessa região da Reserva do Tupé.\r\nUm outro atrativo da Reserva, é a história viva contada por seus moradores, como o Sr. Álvaro Bastos conhecido como \"Barú\". Nascido e criado na região, há alguns anos era um caçador de animais silvestres, utilizando o fruto de suas caçadas para alimentação da sua família. Depois de passar por um processo de convivência com outras pessoas na Reserva, tornou-se um ambientalista e defensor da natureza. \r\nNa comunidade São João do Tupé, existe também um morador chamado Raimundo Silva, caboclo da região. É um autodidata e já escreveu 02 (dois) livros sobre o histórico da comunidade e sobre \"causos\" da região.",
		"filename": "02-04-tupe-pt.mp3",
		"author": "",
		"author_job": ""
	}],
	"more_places": [19, 22, 13, 15, 1]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/3",
	"name": "Palácio da Justiça",
	"small_name": "Palácio da Justiça",
	"id": "3",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Av. Eduardo Ribeiro, 901 - Centro",
	"phone_number": "(92) 3248-1844",
	"opening_hours": "Terça a sábado - 9h às 17h \r\nDomingos - 9h às 14h",
	"desc": "O Palácio da Justiça, inaugurado em 1900, é um dos principais exemplares da arquitetura clássica do período áureo da economia da borracha e suas linhas estruturais seguem o estilo renascentista. Os nomes dados às salas que o compõe homenageiam personalidades ligadas à sua implantação e ao Poder Judiciário. O prédio foi tombado como Patrimônio Histórico e Artístico do Amazonas em 1980.  \r\n\r\nO Palácio está localizado na Avenida Eduardo Ribeiro em ponto privilegiado da principal avenida de Manaus. Hoje o local apresenta ampla programação cultural com exposições de pintura, pocket shows, leituras dramáticas, apresentações teatrais, entre outros.",
	"map_description": "O Palácio da Justiça é um dos prédios mais majestosos da cidade, construído para sediar o poder Judiciário, hoje abriga uma extensa programação cultural. ",
	"social_description": "",
	"location": {
		"lat": "-3.13015279099994",
		"lng": "-60.024419968",
		"timeout": "30",
		"radius": "50",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Palacio-da-Justica/PalacioJustica-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-da-Justica/PalacioJustica-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-da-Justica/PalacioJustica-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-da-Justica/PalacioJustica-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-da-Justica/PalacioJustica-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "A construção do Palácio",
		"description": "Localizado no Centro Histórico de Manaus, na Avenida Eduardo Ribeiro, esse majestoso prédio é um dos mais importantes da cidade. Sua construção foi iniciada em 1894 e concluída em 1900, e tinha como objetivo abrigar o Poder Judiciário do Estado.  \r\nA construção do Palácio da Justiça foi iniciada em 1894, durante a administração do governador Eduardo Ribeiro, porém sua inauguração foi realizada em 21 de abril de 1900. A mobília é centenária. Destaca-se o relógio do tipo carrilhão, da década de 1920, com estrutura de jacarandá baiano e maquinário suíço. Tem também mesa feita de mogno, conjunto de mesas, cadeiras e espelho que vieram da última restauração, em 2002, além de móveis modernos, do funcionamento do Poder Judiciário até 2006 e lustre original feito de bronze e cristais.\r\nSob uma grande expectativa, a inauguração do Palácio teve que ser adiada várias vezes porque a mobília, que estava sendo confeccionada pela Marcenaria Brasileira - a mesma encarregada dos moveis do Salão Nobre do Teatro Amazonas - encontrava-se retida no Rio de Janeiro, por falta de navios-vapores.",
		"filename": "03-01-justica-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}, {
		"title": "Elementos arquitetônicos",
		"description": "É interessante observar o contraste da fachada com o interior do Palácio. Enquanto a fachada tem um estilo sóbrio e mais clássico, o interior é intensivamente decorado, lembrando, inclusive, um teatro. Alguns autores têm interpretado esse contraste como uma ponta de ironia do autor. Aliás, a imagem da justiça que, no geral, é representada como uma mulher com olhos vendados segurando uma balança em equilíbrio, é ligeiramente diferente no caso do Palácio: a estátua não tem venda e a balança tende para um dos lados. Se isto corresponde ou não às verdadeiras intenções do autor não temos como saber.\r\nO edifício possui portões de ferro fundido importados de Glasgow, na Escócia, e calçada e escadarias em pedra de Liós, de Lisboa. O teto do hall é revestido em estuques com paredes em imitação de mármore. A imponente escada principal tem guarda-corpo metálico, com arcos dourados com seis hermas ou cariátides, importadas de Lisboa. O piso do hall é de ladrilhos hidráulicos. O segundo andar é decorado com balaustradas, óculos, tetos recobertos com estuques, colunas, cartelas e paredes marmorizadas, piso de madeira (acapu e pau-amarelo).\r\nOutro elemento importante desde o ponto de vista arquitetônico é a pedra cor de rosa que vemos no portão de entrada ao Palácio e que é a mesma que circunda todo o Teatro Amazonas. Esse belo material é chamado de pedra jacaré e também é conhecida como granito Manaus, porque provém da beira do rio.  No caso do Palácio, encontramos a pedra trabalhada com um detalhe simples, um pequeno relevo, mas que é o único exemplo na cidade de trabalho feito sobre esse material. ",
		"filename": "03-02-justica-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}, {
		"title": "Julgamentos memoráveis",
		"description": "A cidade guarda na memória alguns julgamentos famosos que abalaram a população, fazendo com que as salas do Palácio lotassem. Um dos mais conhecidos foi o crime do jovem Delmo, um assassinato, ocorrido na década de 1950, com requintes de crueldade, que foi notícia nos rádios e revistas da época durante várias semanas.\r\nAtualmente o Palácio da Justiça está aberto para visitação do público e também oferece programação cultural diversa para a população geral. É também sede dos ensaios de orquestras e músicos durante o Festival Amazonas de Ópera, que acontece uma vez por ano no Teatro Amazonas.",
		"filename": "03-03-justica-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}],
	"more_places": [10, 24, 29, 35, 34]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/4",
	"name": "Palácio Rio Negro",
	"small_name": "Palácio Rio Negro",
	"id": "4",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Av. Sete de Setembro, 1546 - Centro",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Terça à sábado - 9h às 17h\r\nDomingos - 9h às 14h.",
	"desc": "Construído em 1903, o então conhecido Palacete Scholz era a residência particular do comerciante de borracha alemão Waldemar Scholz, um dos ricos seringalistas da \"Era da Borracha\". É um dos prédios mais emblemáticos desse período, que marcou a economia do Estado do Amazonas.  \r\n\r\nO imóvel foi adquirido pelo governo em 1917, ocasião em que foi rebatizado como \"Palácio Rio Negro\", e tornou-se sede do Poder Executivo e residência oficial do governador até 1995. \r\n\r\nEm 1997, o imóvel foi transformado em Centro Cultural Palácio Rio Negro, com espaços abertos a recitais de música erudita e instrumental, exposições, lançamentos de livros, dança e teatro, além de outras atividades culturais. ",
	"map_description": "O Palácio Rio Negro, uma construção de inicio do século 20, revela todo o requinte de uma residência particular dos ricos comerciantes da \"Era da Borracha\". ",
	"social_description": "",
	"location": {
		"lat": "-3.13517993899995",
		"lng": "-60.016893996",
		"timeout": "30",
		"radius": "50",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-05-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Palacio-Rio-Negro/PalacioRioNegro-06-1242X1200.jpg"],
	"audio_guide": [{
		"title": "De residência à sede do governo",
		"description": "O Palácio Rio Negro é uma construção de inicio do século XX, que pertenceu ao Barão Waldemar Scholz, comerciante alemão e uma das pessoas mais ricas da cidade na época da borracha. O Barão costumava organizar grandes celebrações no palácio, e era muito querido entre a sociedade local. Uma curiosidade obtida a partir de relatos da época, é que o barão teria ficado cego de um olho enquanto investigava uma garça, de tão interessado que estava no animal. \r\nNa sua origem, o Palácio Rio Negro estava cercado por dois igarapés - na área que hoje abriga o Parque Senador Jefferson Péres - de forma que o Barão podia, descendo pelo Rio Negro, chegar de barco diretamente no quintal da sua residência.\r\nNo final da primeira década do século XX, quando a crise começou a abalar o monopólio amazônico da borracha, o Barão teve que vender o prédio para o Governo do Estado. O Palácio então foi adquirido pelo governador Pedro Bacellar, que transferiu sua sede, até então localizada na praça Dom Pedro II. ",
		"filename": "04-01-rio-negro-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}, {
		"title": "A transformação em centro cultural ",
		"description": "Durante algumas décadas, o palácio que continuou sendo sede do Governo, era aberto ao público apenas em certas datas comemorativas. Em 1997, contudo, o imóvel foi transformado em centro cultural, marcando uma nova história do espaço. Na época, o Palácio abrigou exibições, concertos de música clássica, um café e um restaurante,.\r\nComo parte do projeto de revitalização cultural que teve lugar a partir do ano 2004, o Centro Cultural Rio Negro, junto com outros prédios localizados na região, tornou o centro histórico como o principal eixo cultural da cidade.  \r\n\r\nO Palácio Rio Negro está integrado à Vila Ninita, que fica do lado. Trata-se de uma construção do final do século XIX que, originalmente compunha todo um conjunto, uma vila tradicional, cujas fachadas e outros elementos arquitetônicos foram recuperados também nesta época. Hoje, grande parte da vila original foi demolida para dar lugar ao Parque Senador Jefferson Péres, inaugurado no ano 2009. Do conjunto original mantiveram-se duas casas que atualmente são parte da administração da Secretaria de Cultura do Estado do Amazonas e também são usados para exibição de filmes e outros eventos culturais.",
		"filename": "04-02-rio-negro-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}],
	"more_places": [21, 28, 33, 23, 30]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/10",
	"name": "Teatro Amazonas",
	"small_name": "Teatro Amazonas",
	"id": "10",
	"pmm_priority": true,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Largo de São Sebastião - Centro",
	"phone_number": "(92) 3622-1880",
	"opening_hours": "Segunda a sábado - 9h às 17h \r\nDomingo - 9h às 14h",
	"desc": "Um dos principais símbolos culturais e arquitetônicos de Manaus, o Teatro Amazonas está localizado no Largo de São Sebastião, no Centro Histórico, e mantém viva boa parte da história do ciclo da borracha, época áurea da capital amazonense.  \r\n\r\nInaugurado no dia 31 de dezembro de 1896 e tombado como Patrimônio Histórico Nacional em 1966, o imponente Teatro Amazonas preserva grande parte da arquitetura e decoração originais. O estilo arquitetônico é renascentista, com detalhes ecléticos. A maior parte do material usado na construção do teatro foi importada da Europa: na área externa, a famosa cúpula chama a atenção pela exuberância, composta por 36 mil peças nas cores da bandeira brasileira, importadas da Alsácia, na França; as paredes de aço de Glasgow, na Escócia; e os 198 lustres e o mármore de Carrara das escadas, estátuas e colunas, são da Itália.",
	"map_description": "O Teatro Amazonas e&#769; um dos principais símbolos culturais e arquitetônicos de Manaus e a obra arquitetônica mais significativa do chamado Período Áureo da Borracha no Amazonas. ",
	"social_description": "",
	"location": {
		"lat": "-3.13026415299993",
		"lng": "-60.023361371",
		"timeout": "30",
		"radius": "50",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Teatro-Amazonas/TeatroAmazonas-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Teatro-Amazonas/TeatroAmazonas-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Teatro-Amazonas/TeatroAmazonas-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Teatro-Amazonas/TeatroAmazonas-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Teatro-Amazonas/TeatroAmazonas-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Um símbolo da cidade",
		"description": "O Teatro Amazonas e&#769;, sem dúvida, a obra arquitetônica mais significativa do chamado Período Áureo da Borracha no Amazonas, tanto pelos valores aplicados em sua construção quanto pela importância simbólica que assumiu - vitória do homem sobre a selva, a prosperidade financeira e a pretensa efervescência artística e cultural. Sua construção foi um ato de ostentação de riqueza, e uma peça importante para compor a ideia da vitrine. \r\nPorém, não foi o primeiro teatro que existiu na cidade. Durante o Período Provincial, a Cidade de Manaus ja&#769; tivera um teatro, ainda que singelo. Chamava-se Teatro Phenix e teria sido erguido pela Sociedade Beneficente Portuguesa. À época, já havia um público, ainda que pequeno, interessado em  dramaturgia, mas não se dispõe de muitas informações sobre a origem dos grupos que lá se apresentaram. Posteriormente, seriam construídos outros teatros, como o Edén Teatro ou o Teatro Lisboa.\r\nAtualmente, o teatro, que tem capacidade para 689 pessoas, distribuídas entre a plateia e três pavimentos de camarotes. Com uma programação diversificada, o Teatro Amazonas é o palco de grandes eventos como o Festival Amazonas de Ópera e os festivais de Dança e Teatro; de espetáculos eruditos e populares.",
		"filename": "10-01-teatro-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}, {
		"title": "Um pouco de sua História",
		"description": "A história do Teatro Amazonas foi iniciada em 1881, com a aprovação de um projeto para a construção de um novo teatro, que passou a ser chamado Teatro Provincial e, so&#769; mais tarde, receberia a denominação de Teatro Amazonas.\r\nA questão da autoria do projeto até hoje é discutida. Em novembro de 1882, foi escolhida a proposta apresentada pelo comerciante Anto&#770;nio Bernardo de Oliveira Braga. Porém, mais de dez anos se passaram entre a data da apresentação das plantas e a retomada das obras do teatro. Nesse tempo, houve mudanças não só&#769; na administração local, mas também no regime político nacional, portanto algumas informações que para os pesquisadores atuais seriam consideradas muito importantes, como a autoria do projeto, ficaram sem esclarecimento quando as obras do teatro foram retomadas em 1893.",
		"filename": "10-02-teatro-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}, {
		"title": "Estrutura e decoração ",
		"description": "Para as fachadas e a decoração do teatro foi contratado o cenógrafo pernambucano Crispim do Amaral. Ele, por sua vez, contratou o trabalho de artistas franceses e italianos.\r\nDentre os italianos, o mais destacado é Domenico De Angelis, responsável pela decoração do Salão Nobre. A pintura do teto é assinada por Domenico, assim como os projetos do estuque do teto, do piso, e de vários outros elementos decorativos.\r\nA estrutura do teatro e&#769; bastante convencional, com o tradicional formato de caixa com quatro paredes. A construção do mesmo exigiu o uso de muito material em ferro, principalmente as grandes estruturas que abraçam o prédio assim como o teto e a cúpula. A presença dos elementos em ferro na construção do teatro não e&#769; tão evidente, mas um pouco desse material e&#769; aplicado na decoração, ainda que com função utilitária, como, por exemplo, as grades do guarda-corpo da sala de espetáculo, algumas escadas e corrimãos, ou os próprios bancos localizados no hall de entrada do prédio. A grande maioria desses elementos lembram os desenhos sinuosos típicos do estilo Art Nouveau. ",
		"filename": "10-03-teatro-pt.mp3",
		"author": "Otoni Mesquita",
		"author_job": "Historiador e artista"
	}],
	"more_places": [29, 3, 34, 35, 32]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/12",
	"name": "Museu da Cidade de Manaus",
	"small_name": "Museu da Cidade de Manaus",
	"id": "12",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Gabriel Salgado - Centro",
	"phone_number": "(92) 3582-3188",
	"opening_hours": "Terça a domingo - 9h às 17h",
	"desc": "O Museu da Cidade de Manaus foi inaugurado em 2018, no dia do Aniversário da Cidade, com o propósito de presentear a população amazonense e seus visitantes. O projeto que mostra a identidade do povo manauara por meio de cores, caras, etnias, história e muita tecnologia, é contado pelas mãos, olhar e ideias de Marcello Dantas, produtor e diretor artístico que assina a exposição permanente \"A Cidade de Manaus: história, gente e cultura\". \r\n\r\nOito salas do Museu da Cidade de Manaus retratam a vida cotidiana, a identidade e a cultura de gerações passadas, por meio de exposições de longa e curta duração, utilizando-se da interatividade para contar a história da cidade de Manaus a partir de textos, sons e imagens, com caráter educativo, lúdico e dinâmico e atraindo a atenção, o olhar e a sensibilidade até dos visitantes mais novos",
	"map_description": "O Museu da Cidade de Manaus, inaugurado em 2018, tem como propósito retratar a vida cotidiana, a identidade e a cultura de gerações passadas. ",
	"social_description": "",
	"location": {
		"lat": "-3.13430679599998",
		"lng": "-60.028589096",
		"timeout": "30",
		"radius": "25",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Museu-da-Cidade/Museu-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-da-Cidade/Museu-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-da-Cidade/Museu-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-da-Cidade/Museu-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-da-Cidade/Museu-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Um local da história manauara ",
		"description": "Localizado no Centro Histórico de Manaus, no antigo bairro de São Vicente, o Museu da Cidade de Manaus funciona no Paço da Liberdade, o único edifício com fachada neoclássica existente em Manaus, sendo ainda, uma das mais belas fachadas da cidade.\r\nTambém conhecido no passado como Palácio Municipal, o prédio foi construído para ser sede do governo municipal e durante décadas funcionou com esta finalidade. Hoje, o Paço da Liberdade se tornou a casa que conta a história do povo manauara, reunindo beleza arquitetônica, exposições tecnológicas, peças arqueológicas e artigos regionais. \r\nInaugurado em 24 de outubro de 2018, data em que a cidade de Manaus comemorou 349 anos de sua fundação, o Museu da Cidade de Manaus é um museu de identidade e tem por objetivo resgatar, perpetuar e narrar as muitas transformações sociais, urbanas e culturais que levaram à formação da cidade de Manaus como a conhecemos hoje.  \r\nInterativo, lúdico, dinâmico e educativo, o Museu da Cidade de Manaus guarda um rico repertório das histórias e costumes do povo manauara. \r\nPoucas pessoas sabem que, cerca de 1400 anos atrás, o local onde está construído o Museu da Cidade e a Praça Dom Pedro II, foi habitado por populações indígenas muito antigas. Essas populações deixaram vestígios materiais que nos ajudam a entender como sepultavam seus mortos, o que comiam, como e onde cozinhavam, como eram suas habitações e vários outros aspectos de suas vidas e cultura. Locais como esse são denominados sítios arqueológicos, ou seja, são lugares onde se encontram vestígios da vida dos povos do passado e dos objetos por eles produzidos.\r\nEste sítio arqueológico sobre o qual o Museu repousa recebeu o nome de sítio Manaus. Ele foi descoberto por Peter Paul Hilbert, na década de 1960. Ele estava desenvolvendo pesquisas no Estado do Amazonas quando houve a reforma do atual prédio do INSS, situado ao lado da Praça do Pedro II. E durante essa reforma, ele encontrou uma urna funerária. ",
		"filename": "12-01-muma-pt.mp3",
		"author": "Vanessa de Carvalho Benedito e Margaret Cerqueira",
		"author_job": "Arqueólogas e pesquisadoras"
	}, {
		"title": "Urnas funerárias e Terra Preta de Índio",
		"description": "Urna funerária são vasos feitos de cerâmica, de tamanhos variados, os quais eram utilizados pelos povos do passado para enterrar seus mortos. Reformas realizadas tanto na Praça Dom Pedro II quanto no Museu da Cidade, já nos anos 2000, evidenciaram outros vestígios materiais dessas ocupações antigas, incluindo a descoberta de outras inúmeras urnas funerárias. A partir de então, a área ficou conhecida como antigo cemitério indígena.\r\nNa sala da arqueologia do Museu é possível observar uma dessas urnas funerárias exposta exatamente no local onde foi descoberta.\r\nAlém das urnas funerárias, também foi identificado no sítio Manaus, um solo escuro conhecido na arqueologia como Terra Preta de Índio (TPI). Esse solo foi criado em cima dos solos naturais da Amazônia e sua origem está associada às intervenções humanas realizadas em um período muito anterior à colonização europeia. A criação da TPI tem a ver com a época em que os indígenas começaram a permanecer mais tempo num lugar (sedentarismo), ao aumento da população, ao acúmulo e descarte de material orgânico no solo, como, por exemplo os restos de comida, e ao manejo do solo, como a queimada controlada para práticas de agricultura e horticultura. Esses solos criados pela ação humana apresentam características físicas, químicas e biológicas distintas dos demais tipos de solos naturais. \r\nAs Terras Pretas de Índio são ricas em nutrientes, como carbono, cálcio, fósforo, manganês e magnésio, e podem apresentar até 70 vezes mais níveis de carbono, o que também as diferenciam dos solos naturais. A Terra Preta de Índio está dispersa na Amazônia brasileira e noutros países que compreendem a Amazônia Internacional, como: Venezuela, Colômbia, Equador, Peru e Guiana, desde os Andes até a foz do rio Amazonas, na ilha Marajó, e pode compreender menos de 1 hectare ou vários hectares. ",
		"filename": "12-02-muma-pt.mp3",
		"author": "Vanessa de Carvalho Benedito e Margaret Cerqueira",
		"author_job": "Arqueólogas e pesquisadoras"
	}],
	"more_places": [27, 40, 36, 38, 37]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/11",
	"name": "Mercado Municipal Adolpho Lisboa",
	"small_name": "Mercadão",
	"id": "11",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "R. dos Barés, s/n - Centro",
	"phone_number": "(92) 3215-3473",
	"opening_hours": "Segunda a sábado -  6h às 17h\r\nDomingos - 6h às 13h",
	"desc": "Construído de frente para o rio Negro em 1880, foi oficialmente inaugurado em 1883, quando a cidade de Manaus era considerada uma das mais prósperas do Brasil, graças às riquezas originadas pela exploração dos seringais. Foi construído em estilo Art Nouveau, sendo um dos mais importantes exemplares mundiais da arquitetura de ferro, seguindo as características do antigo Mercado Les Halles de Paris. Por ser um dos principais exemplares da arquitetura de ferro sem similar em todo mundo, foi tombado como Patrimônio Histórico e Artístico Nacional pelo IPAHAN em 1987. \r\n\r\nReinaugurado em 2013, após 7 anos de reforma, o Mercado que possui duas fachadas totalmente distintas, uma de frente para o rio Negro e outra para a via pública, é considerado um dos mais importantes centros de comercialização de produtos típicos da Região Amazônica, em função da vasta variedade de espécies de peixes de água doce, frutas, legumes e especiarias, e se destaca hoje como polo cultural e um dos principais pontos turísticos de Manaus. ",
	"map_description": "O Mercado Municipal Adolpho Lisboa, um dos principais pontos turísticos da cidade, é o local ideal para encontrar os produtos típicos da região.  ",
	"social_description": "",
	"location": {
		"lat": "-3.13994858899997",
		"lng": "-60.02366592",
		"timeout": "30",
		"radius": "45",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Mercado-Municipal-Adolpho-Lisboa/Mercado-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Mercado-Municipal-Adolpho-Lisboa/Mercado-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Mercado-Municipal-Adolpho-Lisboa/Mercado-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Mercado-Municipal-Adolpho-Lisboa/Mercado-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Mercado-Municipal-Adolpho-Lisboa/Mercado-05-1242X1200.jpg"],
	"audio_guide": [{
		"title": "A formação do Mercado",
		"description": "Um dos mais importantes pontos turísticos da Cidade de Manaus, o Mercado Adolpho Lisboa, conhecido também, carinhosamente, como \"Mercadão\", oferece uma vivência única para os seus visitantes. Além do turismo de compras de produtos regionais, é possível ter uma experiência sensorial, onde o turista poderá ver, ouvir, sentir cheiros e degustar sabores conhecendo as cores, os sons e os aromas dos produtos típicos da Amazônia. \r\nLocalizado na Rua dos Barés, no Centro Histórico da Cidade de Manaus, o Mercado encontra-se bem próximo ao Rio Negro.\r\nO mercado começou a se formar espontaneamente há muito tempo, aproximadamente entre o fim do período colonial e o começo do imperial, concentrando produtores, comerciantes e compradores no mesmo local onde se encontra hoje, na beira do rio, por onde as mercadorias eram trazidas e escoadas. \r\nNo século XIX, medidas para melhorar as condições higiênicas, motivaram a construção de um novo mercado público, cuja obra foi iniciada em 1880, com pavilhões construídos e sustentados por 28 colunas de ferro fundido, pela firma Francis Morton Engenheiros da cidade de Liverpool na Inglaterra. ",
		"filename": "11-01-mercado-pt.mp3",
		"author": "Leonardo Granjeiro",
		"author_job": "Administrador do Museu da Cidade de Manaus"
	}, {
		"title": "Construção por fases",
		"description": "Inaugurado em 15 de julho de 1883, no governo de José Paranaguá, então Presidente da Província, esse belo complexo arquitetônico, tinha sua frente para o rio e desfrutava dessa visão privilegiada. \r\nEm anos posteriores, foram construídos dois outros pavilhões laterais, com estrutura formada por beirais vazados, alçados por arcos de ferro, onde é possível ver gradis com ornatos decorados, acompanhados por vidros coloridos. Em meados de 1909, foi construído o pavilhão posterior para a comercialização de quelônios, como tartarugas, tracajás e aiaçás - conforme pratica da época - este edifício possui um formato diferente dos outros, sendo fechado e com cobertura com chapas onduladas. A construção possui portões, gradis e venezianas com estrutura de ferro em seu feitio, além de belos vitrais coloridos. Nas laterais desse pavilhão existem dois outros de menor tamanho e de formato oitavado. Todos esses elementos formam uma bela arquitetura que encanta a todos.",
		"filename": "11-02-mercado-pt.mp3",
		"author": "Leonardo Granjeiro",
		"author_job": "Administrador do Museu da Cidade de Manaus"
	}, {
		"title": "Artesanato e medicina tradicional",
		"description": "O Mercado Municipal é um verdadeiro mostruário do Patrimônio Histórico Imaterial de Manaus. Verdadeira vitrine de saberes e fazeres, de uma cultura miscigenada e muito rica, onde é possível adquirir exemplares de artesanatos como as belas cestarias indígenas com seus trançados e tingimentos cuja técnica de confecção é passada de pai para filho, além de vestimentas, joias, plumagens, cerâmicas, máscaras, instrumentos sonoros e musicais, objetos diversos de caça, pesca, armas e de rituais das tribos que dominaram a região.\r\nAlém disso, pode-se notar as heranças dos costumes de muitos povos que imigraram para Manaus na presença de diversos produtos portugueses, italianos, franceses e sírio-libaneses encontrados no Mercado. O famoso escritor Milton Hatoum, descendente de libaneses, nasceu e viveu nas cercanias do Mercado e descreve a presença dessa cultura em seu livro \"Relato de um Certo Oriente\" e outros.\r\nTambém passado de geração a geração, é o conhecimento da medicina tradicional, que possui enorme o potencial fármaco, medicinal e estético. Produtos naturais são vendidos, como ervas, chás, garrafadas, tônicos, unguentos, pomadas, cremes, para dores, infecções, cansaço, depressão, tratamentos de pele, cabelo, unhas etc.",
		"filename": "11-03-mercado-pt.mp3",
		"author": "Leonardo Granjeiro",
		"author_job": "Administrador do Museu da Cidade de Manaus"
	}, {
		"title": "Gastronomia típica e produtos regionais",
		"description": "A parte gastronômica oferece uma imensa variedade de opções para todos os gostos.\r\nO visitante pode desfrutar de um café da manhã com a famosa tapioca feita na hora ou com o delicioso pão com tucumã, queijo coalho e banana frita, conhecido como \"X-Caboquinho\", uma unanimidade entre os habitantes locais. \r\nJá no almoço, os peixes como tambaqui, pirarucu, jaraqui, pacú ou tucunaré são a melhor opção e você pode saboreá-los com farinha do Uarini e  baião de dois. Para beber, sugerimos um dos muitos sucos de frutas encontradas na região, como o de cupuaçu, buriti, açaí, graviola.\r\nAlém das frutas e verduras regionais, o local oferece também opções de queijos, castanhas do Brasil, farinhas, mel da floresta, doces e bombons de chocolate recheados com cupuaçu e castanha.\r\nO mercado também oferece produtos para a preparação dos deliciosos e tradicionais pratos amazônicos, como o \"tucupi\", molho indígena extraído da mandioca, com o qual se preparam o pato ou a galinha no tucupi, o arroz de pato, o tacacá e outras iguarias do Norte do Brasil. De igual forma, pode-se comprar lá o \"jambú\", uma erva muito nutritiva e saborosa, usada em diversas receitas amazônicas que provoca um efeito sutilmente anestésico nos lábios.\r\nO complexo do Mercado Municipal, devido a sua importância, foi tombado como Patrimônio Histórico e Arquitetônico pelo Instituto do Patrimônio Histórico e Artístico Nacional - IPHAN, em 1987.",
		"filename": "11-04-mercado-pt.mp3",
		"author": "Leonardo Granjeiro",
		"author_job": "Administrador do Museu da Cidade de Manaus"
	}],
	"more_places": [37, 28, 33, 38, 36]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/7",
	"name": "Arena da Amazônia",
	"small_name": "Arena da Amazônia",
	"id": "7",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Av. Constantino Nery, 5001, Flores",
	"phone_number": "(92) 3238-4974",
	"opening_hours": "Visita Guiada: Terça a sábado - 9h às 12h e 14h às 17h (fechamento dos portões).",
	"desc": "A Arena da Amazônia é um estádio multiuso construído para a Copa do Mundo da FIFA 2014, e depois utilizado para os Jogos das Olimpíadas do Rio 2016. A Arena possui um design inovador, inspirado no trançado do paneiro, elemento regional feito por fibras naturais e utilizado pelos povos indígenas.  \r\n\r\nO estádio, que tem capacidade para mais de 44 mil pessoas, foi eleito o 2º melhor estádio do ano de 2014 pelo site inglês Stadium DataBase.   ",
	"map_description": "A&#8239;Arena da Amazônia é um símbolo do esporte amazonense, que foi construída para abrigar jogos da Copa do Mundo Fifa de 2014. ",
	"social_description": "",
	"location": {
		"lat": "-3.08315198499997",
		"lng": "-60.027749408",
		"timeout": "30",
		"radius": "200",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-05-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Arena-da-Amazonia/Arena-06-1242X1200.jpg"],
	"audio_guide": [{
		"title": "A nossa Arena",
		"description": "A Arena da Amazônia é um símbolo do esporte amazonense. Foi construída para abrigar os jogos da Copa do Mundo Fifa de 2014, realizados no Brasil, e dos quais a cidade de Manaus foi subsede, e inaugurada no dia 9 de março do mesmo ano. A Arena multiuso ganhou o nome do antigo estádio 'Vivaldo Lima' que foi demolido para dar lugar ao novo complexo,  mais moderno e confortável que atendesse às necessidades do maior evento esportivo do mundo. \r\nO estádio tem a capacidade de 44.300 pessoas sentadas. A estrutura possui, ainda, 445 assentos para pessoas com deficiência, 68 camarotes e 82 banheiros.",
		"filename": "07-01-arena-pt.mp3",
		"author": "Agnaldo Oliveira Júnior",
		"author_job": "Jornalista"
	}, {
		"title": "A Arena e a Copa do Mundo da FIFA 2014",
		"description": "Com o surgimento do grande estádio de futebol no meio da capital do Amazonas, a Arena da Amazônia possibilitou grandes encontros de torcidas de vários países numa festa nunca antes vivida em Manaus. \r\nOs moradores de Manaus e os torcedores estrangeiros protagonizaram um momento único na capital, uma verdadeira confraternização dentro do palco que se tornou uma das Arenas mais bonitas entre as doze que receberam os jogos da Copa do Mundo da FIFA 2014, segundo a própria organização do evento.\r\nNa primeira fase da Copa do Mundo 2014, a Arena da Amazônia recebeu quatro jogos. Entre as partidas, Manaus teve o privilégio de sediar um dos maiores clássicos do futebol mundial entre Inglaterra e Itália. Os confrontos mostraram ainda escolas diferentes do futebol mundial, como Camarões e Croácia, Estados Unidos e Portugal, além de Honduras e Suíça. Todos os jogos contaram com boa presença do torcedor nas arquibancadas.",
		"filename": "07-02-arena-pt.mp3",
		"author": "Agnaldo Oliveira Júnior",
		"author_job": "Jornalista"
	}, {
		"title": "Arquitetura inspirada na cultura regional",
		"description": "Inspirada na cultura amazônica, a Arena ganhou formatos que lembram o de um cesto indígena muito utilizado para colheita de frutos da floresta. As cadeiras formam um mosaico multicolorido, remetendo às cores dos frutos locais, que se harmonizam com a estrutura externa que a torna única entre os estádios pelo mundo. Elementos da cultura regional foram a inspiração do arquiteto Ralf Amann, do escritório alemão GMP, que assina o projeto. \r\nA Arena da Amazônia foi eleita a segunda melhor arena de 2014, pelo site StadiumDB, tendo a maior pontuação pelo impacto visual, ficando atrás apenas do estádio Hazza Bin Zayed, dos Emirados Árabes. \r\nO maior público foi registrado no dia 18 de agosto de 2019 em partida final disputada entre o Manaus Futebol Clube, time amazonense, e o Brusque de Santa Catarina, pela série D do Campeonato Brasileiro de Futebol, com 44.896 torcedores presentes. Atualmente, a Arena da Amazônia tem sido utilizada como palco para grandes eventos esportivos e musicais. ",
		"filename": "07-03-arena-pt.mp3",
		"author": "Agnaldo Oliveira Júnior",
		"author_job": "Jornalista"
	}],
	"more_places": [20, 16, 6, 18, 5]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/14",
	"name": "Praia Dourada",
	"small_name": "Praia Dourada",
	"id": "14",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Estrada do Tarumã, ramal km 9",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "A praia dourada é uma das mais populares da capital, sobretudo por seu fácil acesso através do ramal no km 9 da estrada do Tarumã. \r\nA praia também é ponto de partida para vários flutuantes e está localizada relativamente próxima ao Complexo Turístico Ponta Negra. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.015553",
		"lng": "-60.093434",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Praia-Dourada/Praia-Dourada-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [15, 13, 1, 22, 7]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/15",
	"name": "Marina do Davi",
	"small_name": "",
	"id": "15",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Estrada da Ponta Negra - Ponta Negra",
	"phone_number": "(92) 3658-6159",
	"opening_hours": "Todos os dias - 7h30 às 18h",
	"desc": "A Marina do Davi é um terminal portuário de pequenas embarcações. A maioria dos transportes de passageiros para diversas comunidades e passeios próximos a Manaus são feitos por ela. No local é possível contratar passeios com destino ao Encontro das Águas, comunidades ribeirinhas, visita a igapós, botos, comunidade indígena e ver a vitória régia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.053006",
		"lng": "-60.108890",
		"timeout": "0",
		"radius": "100",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Marina-do-Davi/MarinaDavi-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [1, 13, 14, 42, 22]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/19",
	"name": "Comunidade Indígena Dessana",
	"small_name": "Comunidade Indígena Dessana",
	"id": "19",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Reserva de Desenvolvimento Sustentável do Tupé. ",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Consulte uma agência de viagens para fazer o passeio até à comunidade.",
	"desc": "A tribo Dessana está localizada na Reserva de Desenvolvimento Sustentável do Tupé.\r\n\r\nA tribo recebe os turistas que podem ver seus rituais, onde cantam, dançam e tocam instrumentos feitos por eles mesmos. Depois do ritual é possível participar de um banquete oferecido por eles e comprar seus artesanatos.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.045928",
		"lng": "-60.25332",
		"timeout": "0",
		"radius": "1000",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Comunidade-Indigena-Dessana/ComunidadeDessana-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Comunidade-Indigena-Dessana/ComunidadeDessana-02-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Comunidade-Indigena-Dessana/ComunidadeDessana-03-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [2, 22, 13, 15, 1]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/22",
	"name": "Museu do Seringal Vila Paraíso",
	"small_name": "Museu do Seringal Vila Paraíso",
	"id": "22",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Igarapé São João (afluente do Igarapé).",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Terça a domingo - 8h às 15h30.",
	"desc": "O museu remete aos visitantes a uma ambientação nos tempos áureos do ciclo da borracha, apresentando um seringal da época e um acervo que inclui móveis e utensílios que\r\nrepresentam a riqueza dos \"barões da borracha\" e da vida do seringueiro na floresta.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.009879",
		"lng": "-60.175455",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Museu-do-Seringal-Vila Paraiso/Museu-do-Seringal-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [13, 15, 14, 19, 2]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/20",
	"name": "Parque Ponte dos Bilhares ",
	"small_name": "Parque Ponte dos Bilhares ",
	"id": "20",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Entre as Avenidas Constantino Nery e Djalma Batista. ",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Todos os dias - 6h às 23h",
	"desc": "O Parque dos Bilhares é um parque urbano com cerca de 60.000 m² localizado às margens do igarapé do Mindu. Conta com diversas opções de lazer e cultura, inúmeros playgrounds, bares, pista de cooper, estacionamentos, campo de futebol, teatro de arena, lago artificial, quadras poliesportivas e ciclovia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.101650",
		"lng": "-60.024298",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Parque-Ponte-dos-Bilhares/Parque-Bilhares-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Ponte-dos-Bilhares/Parque-Bilhares-02-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Ponte-dos-Bilhares/Parque-Bilhares-03-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [7, 6, 18, 39, 16]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/16",
	"name": "Parque Municipal do Mindú",
	"small_name": "",
	"id": "16",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Rua Perimetral, s/n. Parque Dez.",
	"phone_number": "(92) 3236-7702",
	"opening_hours": "Terça a domingo - 7h às 16h30.",
	"desc": "Criado para proteger o sauim-de-coleira do risco de extinção, o parque, localizado a apenas 15 minutos do centro de Manaus, possui 42 hectares de biodiversidade",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.079045",
		"lng": "-60.008065",
		"timeout": "0",
		"radius": "100",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Parque-Municipal-do-Mindu/Parque-do-Mindu-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Municipal-do-Mindu/Parque-do-Mindu-02-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Municipal-do-Mindu/Parque-do-Mindu-03-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Municipal-do-Mindu/Parque-do-Mindu-04-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [7, 18, 5, 20, 6]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/17",
	"name": "Parque Estadual Sumaúma",
	"small_name": "",
	"id": "17",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Av. Bacuri, s/n - Cidade Nova.",
	"phone_number": "(92) 3659-1832",
	"opening_hours": "Terça a domingo - 8h às 17h",
	"desc": "O Parque Estadual Sumaúma possui uma área de 51 hectares. É a primeira Unidade de Conservação Estadual localizada na cidade de Manaus.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.035023",
		"lng": "-59.980752",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Parque-Estadual-Sumauma/Parque-Sumauma-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [9, 16, 5, 7, 18]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/18",
	"name": "Parque Cidade da Criança",
	"small_name": "",
	"id": "18",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Castro Alves, 100 - Aleixo.",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Terça a sexta-feira - 8h às 12h e 13h às 17h\r\nSábado e domingo - 14h às 20h ",
	"desc": "O Parque Cidade da Criança é um espaço repleto de diversão, brincadeiras e atividades direcionadas para a garotada e toda família. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.103969",
		"lng": "-60.001886",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Parque-Cidade-da-Crianca/Parque-Cidade-da-Crianca-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [5, 20, 16, 23, 31]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/13",
	"name": "Praia da Lua ",
	"small_name": "",
	"id": "13",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Acesso de lancha através da Marina do Davi, estrada da Ponta Negra. ",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "A Praia da Lua é uma praia fluvial situada na margem esquerda do rio Negro, a 23 quilômetros de Manaus, acessada por barcos e lanchas. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.032303",
		"lng": "-60.135274",
		"timeout": "0",
		"radius": "1000",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Praia-da-Lua/Praia-da-Lua-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [15, 14, 1, 22, 42]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/21",
	"name": "Parque Senador Jefferson Peres ",
	"small_name": "Parque Senador Jefferson Peres ",
	"id": "21",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Av. Lourenço da Silva Braga, 1507 - Centro.",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Todos os dias - 6h às 22h",
	"desc": "Localizado no entorno do Palácio Rio Negro, no centro histórico de Manaus, em área de 53.421m², é composto de pórtico de entrada em estrutura de ferro com mais de 10m de altura, que lembram os pavilhões do Mercado Adolpho Lisboa; figuras metálicas de bondes elétricos; e casais de namorados vestidos a caráter, retratando o auge do Ciclo da Borracha.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.137476",
		"lng": "-60.016014",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Parque-Senador-Jefferson-Peres/Parque-Jeferson-Peres-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Parque-Senador-Jefferson-Peres/Parque-Jeferson-Peres-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [4, 28, 33, 23, 11]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/23",
	"name": "Museu do Índio",
	"small_name": "",
	"id": "23",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Duque de Caxias, 296. Centro",
	"phone_number": "(92) 3635-1922",
	"opening_hours": "Segunda à sexta - 8h às 16h30\r\nSábados - 8h30 às 11h30.",
	"desc": "Depositário do testemunho material do amazônida e do seu habitat, o Museu do Índio reúne em seu acervo cerca de 3.000 peças produzidas por tribos de diversas etnias da Amazônia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.133211",
		"lng": "-60.011948",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Museu-do-Indio/MuseudoIndio-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-do-Indio/MuseudoIndio-03-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Museu-do-Indio/MuseudoIndio-04-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [4, 21, 28, 33, 30]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/24",
	"name": "Museu Casa Eduardo Ribeiro",
	"small_name": "",
	"id": "24",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua José Clemente, 322. Centro Histórico de Manaus",
	"phone_number": "(92) 3631-2938",
	"opening_hours": "Terça a sábado - 9h às 14h",
	"desc": "O Museu Casa Eduardo Ribeiro, recupera a história pessoal, militar e administrativa do ex-governador Eduardo Gonçalves Ribeiro, importante personagem, considerado o grande transformador da capital amazonense.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130757",
		"lng": "-60.025272",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Museu-Casa-Eduardo-Ribeiro/MuseuEuduardoRibeiro-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [3, 10, 29, 34, 35]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/25",
	"name": "Biblioteca João Bosco Pantoja Evangelista",
	"small_name": "",
	"id": "25",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Costa Azevedo, 216 - (Largo de São Sebastião) Centro",
	"phone_number": "(92) 3215-4615",
	"opening_hours": "Segunda a sexta - 8h às 17h",
	"desc": "A Biblioteca Municipal foi criada em 1967 e recebeu esse nome em homenagem ao professor, escritor, poeta e jornalista João Bosco Pantoja Evangelista, um dos fundadores do Clube da Madrugada e da União Brasileira de Escritores/Seção Amazonas. A biblioteca João Bosco Pantoja Evangelista tem um acervo de aproximadamente 4 mil livros e desenvolve os projetos Aluno Escritor, Janela do Saber e Lendo Lendas, voltados para a rede Municipal de Ensino. \r\nSeu prédio, construído em 1908, no centro histórico de Manaus, encontra-se fechado para reforma e, temporariamente, a biblioteca está funcionando no Largo São Sebastião. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130718",
		"lng": "-60.022156",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Biblioteca-Joao-Bosco-Pantoja-Evangelista/BibliotecaJEvangelista-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [30, 32, 34, 29, 35]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/26",
	"name": "Biblioteca Pública do Amazonas",
	"small_name": "",
	"id": "26",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Barroso, nº 57, Centro",
	"phone_number": "(92) 3234-0588",
	"opening_hours": "Segunda a sexta - 8h às 17h",
	"desc": "Inaugurada em 1912, o prédio histórico abriga obras raras, periódicos antigos, material acadêmico extenso, além de ser um dos edifícios mais belos do Centro de Manaus.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.134335",
		"lng": "-60.023391",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Biblioteca-Publica-do-Amazonas/BibliotecaPublicaAmazonas-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [38, 33, 36, 37, 28]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/27",
	"name": "Instituto Geográfico e Histórico do Amazonas - IGHA",
	"small_name": "Instituto Geográfico e Histórico do Amazonas - IGHA",
	"id": "27",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Frei José dos Inocentes, 132 ? Centro",
	"phone_number": "(92) 3085-3637",
	"opening_hours": "Segunda a sexta - 8h às 12h e 14h às 18h ",
	"desc": "Situado no Centro Histórico de Manaus, o IGHA é a instituição cultural mais antiga do Amazonas. Além de promover seminários e palestras, possui um museu próprio, com valiosas peças históricas, e uma coleção única de peças indígenas. Sua biblioteca e, principalmente, sua hemeroteca são pontos obrigatórios para os que se dedicam a pesquisar sobre a Amazônia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.133627",
		"lng": "-60.029081",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/IGHA/IGHA-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [12, 40, 36, 38, 24]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/28",
	"name": "Palacete Provincial",
	"small_name": "Palacete Provincial",
	"id": "28",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Praça Heliodoro Balbi, Av. sete de setembro, s/nº. Centro",
	"phone_number": "(92) 3631-6047",
	"opening_hours": "Terça a sexta - 9h às 17h\r\nSábado e domingo - 9h às 14h",
	"desc": "É uma das edificações mais antigas da cidade, inaugurado em 1875 e conhecido por mais de 100 anos como Quartel da Polícia Militar. \r\nAtualmente abriga cinco museus em diferentes espaços: Museu de Numismática, Museu da Imagem e do Som do Amazonas, Pinacoteca do Estado, Museu Tiradentes (Museu da Polícia Militar do Estado) e o Museu de Arqueologia. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.135493",
		"lng": "-60.021046",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Palacete-Provincial/Palacete-Provincial-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [33, 26, 38, 37, 4]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/29",
	"name": "Casa das Artes",
	"small_name": "Casa das Artes",
	"id": "29",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua José Clemente, 564 - Centro.",
	"phone_number": "(92) 3631-6227",
	"opening_hours": "Terça a domingo - 15h às 21h ",
	"desc": "Atualmente na Casa das Artes funciona a administração do Centro Cultural Largo de São Sebastião. O espaço também recebe exposições temporárias, e, no mês de dezembro, é transformado na Casa do Papai Noel.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130873",
		"lng": "-60.023084",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Casa-das-Artes/CasadasArtes-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [10, 34, 25, 32, 30]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/30",
	"name": "Galeria do Largo São Sebastião ",
	"small_name": "Galeria do Largo São Sebastião ",
	"id": "30",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Costa Azevedo, 290 - Centro.",
	"phone_number": "(92) 3631-4786",
	"opening_hours": "Terça a domingo - 15h às 20h ",
	"desc": "Inaugurada durante o 2° Amazonas Film Festival, em um casarão histórico, com uma exposição de cartazes de filmes históricos do cinema nacional. No mesmo ano o espaço abriu as portas como galeria pública de caráter comercial com a exposição ?Visões Contemporâneas? dos artistas plásticos Sergio Cardoso, Jair Jacqmont e Otoni Mesquita. Ela mantém a exposição permanente ?Cidade Santa Anita?, de Mário Ypiranga Monteiro, e exposições temporárias.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130922",
		"lng": "-60.021922",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Galeria-do-Largo-Sao-Sebastiao/GaleriadoLargo-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [25, 32, 34, 29, 35]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/31",
	"name": "Centro Cultural Povos da Amazônia",
	"small_name": "Centro Cultural Povos da Amazônia",
	"id": "31",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Praça Francisco Pereira da Silva, s/n° (Bola da Suframa)",
	"phone_number": "(92) 2123-5300",
	"opening_hours": "Espaço criança - Terça a sexta - 8h30 às 12h;\r\nDemais espaços - 13h às 17h e domingo - 16h às 21h",
	"desc": "O complexo reúne em um só local, informação, entretenimento e pesquisa sobre as populações da Amazônia Ocidental, com objetivo de difundir a cultura e o conhecimento das populações do Brasil, Bolívia, Colômbia, Equador, Guiana, Peru, Suriname e Venezuela.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.132995",
		"lng": "-59.987284",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Centro-Cultural-Povos-da-Amazonia/CCPA-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [23, 21, 4, 18, 28]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/32",
	"name": "Musa Largo São Sebastião",
	"small_name": "",
	"id": "32",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Costa Azevedo, 272 - Centro",
	"phone_number": "(92) 99280-9059",
	"opening_hours": "Segunda a sábado - 9h às 18h",
	"desc": "Um galpão adaptado pelo Museu da Amazônia com a finalidade de realizar exposições, conferências, recitais, além de ser um espaço dedicado ao debate e à popularização da ciência, das artes e da cultura, à memória e à história da Amazônia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130235",
		"lng": "-60.022130",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Musa-Largo-Sao-Sebastiao/Musa-Largo-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [34, 25, 35, 30, 29]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/33",
	"name": "Praça Heliodoro Balbi",
	"small_name": "",
	"id": "33",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Avenida Sete de Setembro, s/n - Centro",
	"phone_number": "(92) 3131-2450 ",
	"opening_hours": "Aberto 24 horas",
	"desc": "Considerada ponto tradicional da cidade, aberta ainda na época do Império, a Praça Heliodoro Balbi, ou Praça da Polícia, ocupa uma área de 8.515 m², no centro da cidade de Manaus. Abriga atualmente o Palacete Provincial, espaço cultural da cidade.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.135221",
		"lng": "-60.021278",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Praca-Heliodoro-Balbi/Praca-Heliodoro-Balbi-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Praca-Heliodoro-Balbi/Praca-Heliodoro-Balbi-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [28, 26, 38, 37, 36]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/34",
	"name": "Largo São Sebastião",
	"small_name": "",
	"id": "34",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua 10 de Julho - Centro",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "A praça inclui o Teatro Amazonas e seus arredores, com a Casa J.G Araújo, Casa da Restauração, Casa Ivete Ibiapina, Casa das Artes, Igreja São Sebastião, a Galeria das Artes e o monumento comemorativo à Abertura dos Portos do Estado do Amazonas.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.130262",
		"lng": "-60.022545",
		"timeout": "0",
		"radius": "50",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Largo-Sao-Sebastiao/Largo-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Largo-Sao-Sebastiao/Largo-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [32, 35, 25, 29, 30]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/35",
	"name": "Igreja São Sebastião",
	"small_name": "",
	"id": "35",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua 10 de Julho - Centro",
	"phone_number": "(92) 3232-4572",
	"opening_hours": "Segunda a sexta - 8h às 12h  e 14h às 18h\r\nSábado - 8h às 12h",
	"desc": "Construída em 1888, em estilo gótico e neoclássico, seu interior é marcado por painéis e vitrais europeus, bem ao estilo da época áurea da borracha.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.129772",
		"lng": "-60.022632",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Igreja-Sao-Sebastiao/IgrejaSaoSebastiao-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Igreja-Sao-Sebastiao/IgrejaSaoSebastiao-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [34, 32, 10, 25, 29]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/36",
	"name": "Igreja Matriz de Nossa Senhora da Conceição",
	"small_name": "",
	"id": "36",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Praça Osvaldo Cruz, s/n - Centro",
	"phone_number": "(92) 3234-7821",
	"opening_hours": "Segunda - 15h às 18h\r\nTerça a sexta - 9h às 19h\r\nSábado - 8h às 12h  e 15h às 19h\r\nDomingo - 7h30 às 12h e 17h às 19h",
	"desc": "Também conhecida como Catedral Metropolitana de Manaus Nossa Senhora da Conceição, a igreja é a mais antiga da capital e está localizada no centro histórico da cidade, área tombada como patrimônio histórico em 1988 pelo Iphan (Instituto do Patrimônio Histórico e Artístico Nacional).",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.135461",
		"lng": "-60.025458",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Igreja-da-Matriz/IgrejaMatriz-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [38, 37, 26, 40, 12]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/37",
	"name": "Relógio Municipal de Manaus",
	"small_name": "",
	"id": "37",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Avenida Eduardo Ribeiro, Praça XV de Novembro (Praça da Matriz) - Centro",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "Construído no início do século XX, o Relógio Municipal foi instalado na Avenida Eduardo Ribeiro, compondo a paisagem arquitetônica da Praça da Matriz. Em estilo neoclássico e engrenagem de origem suíça, o Relógio Municipal de Manaus faz parte do Patrimônio Histórico Estadual do Amazonas, tombado em 1988. ",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.136154",
		"lng": "-60.025032",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Relogio-Municipal-de-Manaus/Relogio-Municipal-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [36, 38, 26, 40, 33]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/38",
	"name": "Praça XV de Novembro",
	"small_name": "",
	"id": "38",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Entre a rua XV de novembro e Avenida Eduardo Ribeiro - Centro",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "A Praça XV de Novembro está localizada no Centro de Manaus, em frente ao terminal marítimo, onde teve início o povoamento da região. Formada ao redor da Igreja Matriz de Nossa Senhora da Conceição, ela passou a ser carinhosamente chamada de Praça da Matriz, e há registros de viajantes que a relatam desde 1838.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.135237",
		"lng": "-60.024792",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Praca-XV-de-Novembro/Praca-XV-Novembro-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [36, 37, 26, 33, 40]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/39",
	"name": "Praça da Saudade",
	"small_name": "",
	"id": "39",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rua Simão Bolívar - Centro",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "A Praça da Saudade é uma praça pública localizada no Centro de Manaus. É considerada uma das praças mais antigas da cidade e possui aproximadamente 12,6 mil metros quadrados.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.127451",
		"lng": "-60.025909",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Praca-da-Saudade/Praca-da-Saudade-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [3, 24, 10, 35, 34]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/40",
	"name": "Porto de Manaus",
	"small_name": "",
	"id": "40",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "R. Taqueirinha, 25 - Centro",
	"phone_number": "(92) 3233-7061",
	"opening_hours": "Aberto 24 horas",
	"desc": "O Porto de Manaus é o maior porto flutuante do mundo e está localizado na costa oeste do Rio Negro, no Centro da cidade de Manaus. No local é possível contratar passeios para o Encontro das Águas, comunidades ribeirinhas, e visita a igapós, botos, comunidade indígena e vitória régia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.135504",
		"lng": "-60.028392",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Porto-de-Manaus/Porto-Manaus-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Porto-de-Manaus/Porto-Manaus-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [12, 27, 36, 37, 38]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/41",
	"name": "Porto da Ceasa",
	"small_name": "",
	"id": "41",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Av. Min. Mário Andreazza, 913 - Vila Buriti",
	"phone_number": "(92) 99505-4767",
	"opening_hours": "Aberto 24 horas",
	"desc": "O Porto da Ceasa é um terminal portuário por onde chegam e partem pequenas embarcações que fazem passeios próximos à Manaus, assim como trajetos mais longos, com destino às cidades amazonenses do interior do Estado. No local é possível contratar passeios para Encontro das Águas, comunidades ribeirinhas, e visita a igapós, botos, comunidade indígena e vitória régia.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.134570",
		"lng": "-59.939881",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Porto-da-Ceasa/Porto-Ceasa-01-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [8, 31, 5, 18, 23]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/42",
	"name": "Ponte Jornalista Phelippe Daou",
	"small_name": "",
	"id": "42",
	"pmm_priority": false,
	"has_totem": false,
	"type": {
		"key": "culturais",
		"text": "Centros Culturais"
	},
	"address": "Rodovia, AM-070, S/N.",
	"phone_number": "(92) 3131-2450",
	"opening_hours": "Aberto 24 horas",
	"desc": "Popularmente conhecida como Ponte Rio Negro, é a maior ponte estaiada em águas fluviais do Brasil. A ponte, que atravessa o Rio Negro, conecta os municípios de Manaus e Iranduba, que por sua vez dá acesso também aos municípios de Manacapuru e Novo Airão, ambos na Região Metropolitana de Manaus.",
	"map_description": "",
	"social_description": "",
	"location": {
		"lat": "-3.118793",
		"lng": "-60.078467",
		"timeout": "0",
		"radius": "0",
		"on_entry": false,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Ponte-Jornalista-Phelippe-Daou/Ponte-Jornalista-Phelippe-Daou-01-1242x1200.jpg", "https://descubra.manaus.am.gov.br/images/Ponte-Jornalista-Phelippe-Daou/Ponte-Jornalista-Phelippe-Daou-02-1242x1200.jpg"],
	"audio_guide": [],
	"more_places": [6, 27, 12, 40, 39]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/6",
	"name": "Zoológico do CIGS",
	"small_name": "Zoo CIGS",
	"id": "6",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Estrada do Ponta Negra, 750 - São Jorge",
	"phone_number": "(92) 3659-1000",
	"opening_hours": "Terça a domingo - 9h às 16h30",
	"desc": "Criado e administrado pelo Exército Brasileiro, o Zoológico do Centro de Instrução de Guerra na Selva - CIGS, foi aberto ao público em 1969. Ocupa uma área de 36.000 m² coberta em sua maior parte de vegetação amazônica. O Zoológico abriga exclusivamente espécimes da fauna amazônica e aloja 69 animais, sendo 52 mamíferos, 33 aves, 107 répteis e 265 peixes, totalizando uma riqueza de 68 espécies, das quais várias estão enquadradas nas diversas categorias do IBAMA de ameaça de extinção no restante do Brasil.  \r\n\r\nTodos os animais são oriundos de órgãos ambientais, criadouros autorizados, outros zoológicos e apreensões do tráfico. Por estar inserido dentro de um fragmento de Floresta Amazônica, o zoológico frequentemente recebe a visita de animais de vida livre, que às vezes podem ser avistados durante a visita, tais como preguiças, garças e pica-pau. ",
	"map_description": "O Zoológico do CIGS é o único Zoológico Militar existente no mundo e ocupa área de 36.000m2 em meio a um fragmento de floresta amazônica. ",
	"social_description": "",
	"location": {
		"lat": "-3.10005895999996",
		"lng": "-60.044766055",
		"timeout": "30",
		"radius": "200",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Cigs/Cigs-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Cigs/Cigs-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Cigs/Cigs-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Cigs/Cigs-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Cigs/Cigs-05-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Cigs/Cigs-06-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Sua origem",
		"description": "O Centro de Instrução de Guerra na Selva (CIGS) é uma organização militar do Exército Brasileiro destinada a especializar militares como guerreiros de selva, combatentes aptos a cumprir missões de natureza militar nas áreas mais inóspitas da Amazônia. \r\nCom o objetivo de apoiar as atividades de ensino para os militares dos Cursos de Operações na Selva ministrados pelo CIGS, em 1967 foi criado o Zoológico (Zoo CIGS), idealizado pelo primeiro comandante do Centro, Coronel Jorge Teixeira, conhecido como \"Teixeirão\". \r\nNaquela época, o Zoológico foi estruturado para apoiar a formação dos militares guerreiros de selva para que pudessem conhecer a fauna regional, as características, o comportamento e a biologia dos animais encontrados na Selva Amazônica.",
		"filename": "06-01-cigs-pt.mp3",
		"author": "Camila Tochetto",
		"author_job": "Chefe da Divisão de Veterinária do CIGS"
	}, {
		"title": "Cuidando da fauna amazônica",
		"description": "Devido ao potencial turístico do Zoológico, em 1969 seus portões foram abertos para visitação pública e, desde então, o Zoo CIGS é um dos pontos turísticos mais visitados da cidade de Manaus. \r\nNo Zoo CIGS são encontrados exclusivamente animais da fauna amazônica, entre aves, répteis, mamíferos e peixes. Os animais que vivem no local não possuem condições de retornar à natureza, muitos sofreram maus-tratos, cativeiro ilegal e tráfico e foram destinados ao zoológico por órgãos ambientais. Os filhotes que chegam ao Zoo CIGS são animais que tiveram a mãe morta por caçadores, realidade ainda comum, principalmente para as onças. \r\nAo serem encaminhados ao Zoológico, todos os animais recebem atendimento especial pela equipe de veterinários e biólogos, e após se adaptarem ao local ficam disponíveis à visitação",
		"filename": "06-02-cigs-pt.mp3",
		"author": "Camila Tochetto",
		"author_job": "Chefe da Divisão de Veterinária do CIGS"
	}, {
		"title": "História dos animais",
		"description": "Conheça agora a história de alguns animais que vivem no Zoológico: Simba e Cunhã, o casal de onças: Simba chegou ao Zoológico ainda filhote, após sua mãe ter sido morta. Apresentava fraturas nos ossos dos membros posteriores e da coluna e, após cirurgia e fisioterapia, Simba se recuperou. Hoje, com 18 anos, apesar de andar com alguma dificuldade devido às fraturas, é muito ativo e simpático. Simba vive com Cunhã, de 7 anos, que assim como ele também chegou filhote e com fraturas em um dos membros posteriores. Cunhã também passou por cirurgia e fisioterapia, se recuperando totalmente das fraturas. Desde filhote apresenta perda progressiva de visão por lesão irreversível na retina, cuja causa não pode ser estabelecida. As limitações nunca foram problema para Simba e Cunhã, que se alimentam normalmente, brincam e descansam juntos em seu recinto. \r\nSansão, a onça parda: Sansão vivia acorrentado e dentro de uma jaula de madeira, em um município do interior do Amazonas. Não recebia alimentação adequada e estava abaixo do peso quando foi resgatado pelo IBAMA e destinado ao Zoo CIGS. Hoje, Sansão têm 13 anos e está bem adaptado à sua vida no Zoológico, é uma onça tímida e raramente gosta de aparecer para os visitantes. \r\nAlém das onças, o visitante pode apreciar diversas espécies de mamíferos, dentre eles os primatas, que se localizam em uma grande ilha na área central do Zoológico. Várias espécies de aves também são encontradas no local, como o emblemático gavião real. \r\nO público também poderá conhecer espécies de répteis, como o jacaré-açu, com mais de 3 metros, e a famosa cobra sucuri. Outras atrações são o Aquário Amazônico, a Sala Entomológica, o memorial destinado ao fundador do CIGS, \"Memorial Jorge Teixeira\", o Espaço Cultural \"Exército Brasileiro, Presença na Amazônia\" e a Oca do Conhecimento Ambiental, local destinado à educação ambiental. \r\nO Zoológico do CIGS é o único Zoológico Militar existente no mundo e ocupa uma área de 36.000m2 em meio a um fragmento da floresta amazônica. Conhecer esse espaço destinado à preservação e à conservação da fauna é uma experiência enriquecedora e única. ",
		"filename": "06-03-cigs-pt.mp3",
		"author": "Camila Tochetto",
		"author_job": "Chefe da Divisão de Veterinária do CIGS"
	}],
	"more_places": [20, 7, 39, 24, 3]
}, {
	"share_url": "https://descubra.manaus.am.gov.br/meta/places/pt/5",
	"name": "Bosque da Ciência - INPA",
	"small_name": "Bosque da Ciência",
	"id": "5",
	"pmm_priority": true,
	"has_totem": true,
	"type": {
		"key": "naturais",
		"text": "Atrativos Naturais"
	},
	"address": "Av. Bem Te Vi (antiga Rua Otávio Cabral), s/n - Petropólis - CEP: 69067-001 (anexo à Sede do Instituto Nacional de Pesquisas da Amazônia - INPA)",
	"phone_number": "(92) 3643-3192",
	"opening_hours": "Terça a sexta - 9h às 12h e 14h às 17h\r\nSábados, domingos e feriados - 9h às 16h",
	"desc": "Localizado na área urbana de Manaus, nas dependências do Instituto Nacional de Pesquisas da Amazônia (INPA), o Bosque da Ciência, inaugurado em 1º  de abril de 1995, é um espaço dedicado à divulgação cientifica, educação e lazer, que abriga uma vegetação florestal e animais da fauna amazônica de vida livre. Possui uma área de aproximadamente 13 (treze) hectares, e está localizado no perímetro urbano da cidade de Manaus, na Zona Central - Leste. \r\nNo local é possível visitar ainda a \"Casa da Ciência\", espaço expositivo destinado à realização de atividades que promovam o interesse pela ciência.  Em junho de 2019 foi inaugurada a exposição \"Tramas da Ciência\", na qual o visitante é apresentado às inúmeras variações do ofício de fazer ciência, algumas vezes tendo a oportunidade de se colocar no papel do pesquisador. A exposição é interativa e dirigida ao público de todas as idades.\r\n",
	"map_description": "O Bosque da Ciência, do Instituto Nacional de Pesquisas da Amazônia (INPA), é um fragmento florestal urbano de 13 hectares, para fugir da agitação e calor da cidade.",
	"social_description": "",
	"location": {
		"lat": "-3.09493209599998",
		"lng": "-59.987777082",
		"timeout": "30",
		"radius": "180",
		"on_entry": true,
		"google_maps_share": "",
		"google_maps_embedded": ""
	},
	"imgs": ["https://descubra.manaus.am.gov.br/images/Inpa/Inpa-01-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-02-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-03-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-04-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-05-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-06-1242X1200.jpg", "https://descubra.manaus.am.gov.br/images/Inpa/Inpa-07-1242X1200.jpg"],
	"audio_guide": [{
		"title": "Um fragmento de floresta na cidade",
		"description": "Se você está buscando um pouco de paz e tranquilidade para fugir da agitação e calor da selva de pedra, então visite o Bosque da Ciência do Instituto Nacional de Pesquisas da Amazônia - INPA. O Bosque é um fragmento florestal urbano de 13 hectares onde é possível ter um contato direto com a natureza amazônica, observar animais de vida livre, e conhecer as plantas e um pouco da cultura local. São mais de 20 atrativos naturais, expositivos e tecnologias desenvolvidas por pesquisadores do INPA que estão abertas à visitação pública.\r\nO Bosque da Ciência foi inaugurado em 1º de abril de 1995 integrando as comemorações dos 40 anos do INPA, e por ano, o parque recebe entre 100 e 120 mil visitantes. ",
		"filename": "05-01-inpa-pt.mp3",
		"author": "Rita Mesquita",
		"author_job": "Coordenadora de extensão"
	}, {
		"title": "O jardim botânico e a Casa da Ciência",
		"description": "O Bosque da Ciência é fruto de uma visão do INPA sobre a importância de aproximar as pessoas da ciência, ao mesmo tempo em que conserva uma área verde, que sofria pressão da ocupação urbana com a expansão da cidade. Ao longo dos anos, a vegetação do Bosque da Ciência foi manejada e enriquecida com exemplares de plantas de diferentes locais da Amazônia, muitas delas espécies úteis. Assim, o que antes era um espaço usado apenas por pesquisadores e estudantes, se tornou um agradável \"jardim botânico\" da cidade. \r\nUm dos maiores conhecedores da flora amazônica, o botânico Adolpho Ducke (1876-1959), disse que a área onde está situada Manaus representa uma verdadeira síntese da flora e fauna da região. No Bosque da Ciência o visitante pode ter uma \"imersão\" nessa imensa riqueza natural sem sair da cidade. Sumaúma - conhecida como a árvore gigante da Amazônia; castanha do Brasil; seringueira; andiroba; castanha-de-galinha; sorvinha; pupunha e a tanimbuca - uma árvore com mais de 600 anos, compõem as mais de 70 espécies encontradas no parque. \r\nVale muito a pena reservar um tempinho durante o passeio para conhecer a exposição Tramas da Ciência, na Casa da Ciência - antiga residência do Diretor do INPA. Além da famosa folha gigante da Coccoloba medindo 2,50mx1,44m e premiada pelo Guiness Book em 1997, a exposição dá uma bela visão panorâmica sobre a biodiversidade amazônica e as interações entre humanos e não humanos na região.",
		"filename": "05-02-inpa-pt.mp3",
		"author": "Rita Mesquita",
		"author_job": "Coordenadora de extensão"
	}, {
		"title": "Nossos hóspedes",
		"description": "Os animais são uma atração de encher os olhos. Eles ajudam a floresta do bosque a se renovar e encantam os visitantes com sua beleza e comportamento peculiar. O visitante mais atento vai conhecer vários exemplares da biodiversidade nativa e observar importantes interações entre as espécies de vida livre. Alguns estão em recintos próprios, como peixes-bois da Amazônia, ariranha, jacarés, tartarugas, peixes, poraquê; outros vivem livremente no ambiente. Não se assuste se você se deparar com macacos, cutias, preguiças, aves e uma variedade de insetos soltos no Bosque. \r\nNos tanques dos peixes-bois, no Parque Aquático Robin C. West, mora desde 1974 a Boo, que teve a mãe morta quando ainda era filhote. Ela foi o segundo peixe-boi a chegar ao INPA. Lá ela cresceu, reproduziu-se em cativeiro, teve três filhotes (Erê, Kinja e Ayrumã, todos ainda no parque). Boo adotou ainda outros dois filhotes, como uma verdadeira mãe, e ajudou os pesquisadores a entender melhor a sua espécie, que está ameaçada de extinção. Dóceis e de movimentos lentos, esses animais são alvos fáceis para a caça ilegal. \r\nVenha descobrir este e outros mistérios do Bosque da Ciência!",
		"filename": "05-03-inpa-pt.mp3",
		"author": "Rita Mesquita",
		"author_job": "Coordenadora de extensão"
	}],
	"more_places": [18, 16, 31, 20, 7]
}];

export default places;